module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('timeline', {
    staticClass: "sidebar__content--students timeline--students",
    attrs: {
      "items": _vm.students,
      "isActive": _vm.isStudentActive
    },
    on: {
      "click": _vm.viewStudent
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(student) {
        return [_c('div', {
          staticClass: "timeline__hoverable"
        }, [_c('header', {
          staticClass: "timeline__header"
        }, [_c('h3', {
          staticClass: "timeline__title"
        }, [_c('span', {
          staticClass: "mini-visible"
        }, [_vm._v(_vm._s(_vm.initials(student)))]), _c('span', {
          staticClass: "mini-hidden"
        }, [_vm._v(_vm._s(_vm.username(student)))])])])])]
      }
    }])
  }, [_c('template', {
    slot: "empty"
  }, [_vm._v("\n        Geen leerlingen gevonden\n    ")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70873f39","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/sidebar/SidebarContentStudents.vue
// module id = iAAw
// module chunks = 1